export function submitCharliTiming(lifecycle, config) {
  if (
    !lifecycle?.terminal ||
    typeof lifecycle.requestId !== "string" ||
    !Number.isInteger(lifecycle.durationMs) ||
    typeof config?.endpoint !== "string" ||
    !config.endpoint ||
    typeof config?.nonce !== "string" ||
    !config.nonce
  ) {
    return false;
  }

  const request = fetch(config.endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      requestId: lifecycle.requestId,
      outcome: lifecycle.outcome,
      durationMs: lifecycle.durationMs,
      nonce: config.nonce,
    }),
    credentials: "same-origin",
    keepalive: true,
  });

  request.catch(() => {});
  return true;
}
